<script>
import { mapActions } from 'vuex';
import types from '@/../../common/transparency-type';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Transparency'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Transparency'
        };
    },

    computed: {
        labels() {
            return [
                {
                    value: 'name',
                    width: '150px'
                },
                {
                    value: 'type',
                    type: 'enum',
                    enumOptions: types,
                    width: '150px'
                },
                {
                    value: 'meetingDate',
                    type: 'date',
                    filter: 'dateOnly',
                    width: '150px'
                },
                {
                    value: 'campuses',
                    width: '150px',
                    filterFieldName: 'campuses.name',
                    sortable: false,
                    filter: 'joinTable'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'transparency/index',
            deleteItem: 'transparency/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/transparency/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/transparency/add');
        }
    }
};
</script>
